import { NichtGefunden, WelcheSendungen, NichtErhalten, MeineAmazonSendung } from './Faqs';
import { FAQListComponent } from './FAQListComponent/FAQList.component'
import React from 'react';
import './FAQ.component.scss';

type list = { title: string, component: React.ReactNode }[];

const faqlist: list = [
  {
    title: 'Welche Sendungen kann ich nachverfolgen?',
    component: <WelcheSendungen />
  },
  {
    title: 'Meine Sendung wird unter „Sendungsverfolgung“ nicht gefunden. Was heißt das?',
    component: <NichtGefunden />
  },
  {
    title: 'Die Sendung befindet sich laut Sendungsverfolgung der PIN AG in Zustellung, ich habe sie aber noch nicht erhalten.',
    component: <NichtErhalten />
  },
  {
    title: 'Wo ist meine Amazon/Momox-Sendung?',
    component: <MeineAmazonSendung />
  }
]

export const FAQComponent: React.FC = () => (
  <div className='faq-container mt-5'>
    <h2>Häufige Fragen zur Sendungsverfolgung</h2>

    {faqlist.map((faq, index) => (
      <FAQListComponent key={index} title={faq.title}>
        {faq.component}
      </FAQListComponent>
    ))}
  </div>
);
